import api from "../../system/api";
import {getStorage} from "../../system/storage";

// Goal updates, reminders, AI analysis and the end-of-period review (backend: src/goals in zofino-strapi;
// docs/tasks/17-goal-updates.md).

const data = (response) => response?.data?.data;
const config = (extra = {}) => ({...extra, headers: {workspace: getStorage("workspace"), ...(extra.headers || {})}});

export const goalUpdateApi = {
    list: async (goal) => data(await api.get(`/goal-updates/goal/${goal}`, config())),
    create: async (goal, update) => data(await api.post(`/goal-updates/goal/${goal}`, {data: update}, config())),
    get: async (documentId) => data(await api.get(`/goal-updates/item/${documentId}`, config())),
    // «ارسال به‌صورت پیام»: {people, chats, note} → card messages in private chats and group chats
    share: async (documentId, payload) => data(await api.post(`/goal-updates/item/${documentId}/share`, {data: payload}, config())),
    // group chats the member is in (used by goal and project update modals)
    shareChats: async () => data(await api.get("/goal-updates/share/chats", config())),
    setReminder: async (goal, reminder) => data(await api.put(`/goal-updates/goal/${goal}/reminder`, {data: reminder}, config())),
    analyze: async (goal) => data(await api.post(`/goal-updates/goal/${goal}/analysis`, {data: {}}, config({timeout: 120000}))),
    periodReview: async () => data(await api.get("/goal-updates/period-review", config())),
    decidePeriodReview: async (decisions) => data(await api.post("/goal-updates/period-review", {data: {decisions}}, config())),
    later: async () => data(await api.post("/goal-updates/period-review/later", {data: {}}, config())),
};

export const GOAL_STATUS = {
    "on-way": {label: "در مسیر", icon: "check", tone: "green", open: true},
    "has-risks": {label: "در معرض ریسک", icon: "warning", tone: "orange", open: true},
    "out-of-way": {label: "خارج از مسیر", icon: "dangerous", tone: "red", open: true},
    achieved: {label: "بدست آمده", icon: "done_all", tone: "green", open: false},
    canceled: {label: "لغو شده", icon: "close", tone: "gray", open: false},
    archived: {label: "بیخیالش شدیم", icon: "horizontal_rule", tone: "gray", open: false},
};
export const OPEN_GOAL_STATUSES = ["on-way", "has-risks", "out-of-way"];
export const CLOSED_GOAL_STATUSES = ["achieved", "canceled", "archived"];

export const REMINDER_FREQUENCIES = [
    {value: "weekly", label: "هفتگی (شنبه‌ها)"},
    {value: "biweekly", label: "دو هفته یک‌بار (شنبه‌ها)"},
    {value: "monthly", label: "ماهانه (اول هر ماه)"},
    {value: "quarterly", label: "فصلی (اول هر فصل)"},
];

export function formatPersianDate(value, withTime = false) {
    if (!value) return "";
    try {
        return new Date(value).toLocaleString("fa-IR", {
            timeZone: "Asia/Tehran",
            day: "numeric",
            month: "long",
            year: "numeric",
            ...(withTime ? {hour: "2-digit", minute: "2-digit"} : {}),
        });
    } catch (error) {
        return "";
    }
}

// the text areas hold one item per line
export const linesToList = (value) => String(value || "").split("\n").map((line) => line.trim()).filter(Boolean);
export const listToLines = (value) => (Array.isArray(value) ? value : []).join("\n");
